import type { Instance } from 'flatpickr/dist/types/instance'
import type { Options } from 'flatpickr/dist/types/options'

import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'

class FormDate {
  private dateInputs: HTMLInputElement[]
  private readonly defaultDisplayFormat = 'd.m.Y'
  private readonly submitFormat = 'Y-m-d'

  constructor () {
    this.dateInputs = Array.from(
      document.querySelectorAll<HTMLInputElement>('[data-form-date]')
    )
  }

  public init (): void {
    this.dateInputs.forEach((input: HTMLInputElement): void => {
      flatpickr(input, this.buildOptions(input))
    })
  }

  private buildOptions (input: HTMLInputElement): Options {
    const altFormat = input.getAttribute('data-datepicker-format') || this.defaultDisplayFormat
    const options: Options = {
      allowInput: true,
      altFormat,
      altInput: true,
      dateFormat: this.submitFormat,
      locale: German,
      onReady: (_dates, _str, instance: Instance): void => this.linkLabelToAltInput(instance)
    }

    const minDate = input.getAttribute('min')
    if (minDate) {
      options.minDate = minDate
    }

    const maxDate = input.getAttribute('max')
    if (maxDate) {
      options.maxDate = maxDate
    }

    if (input.value) {
      options.defaultDate = input.value
    }

    return options
  }

  private linkLabelToAltInput (instance: Instance): void {
    const original = instance.input
    const alt = instance.altInput
    if (!alt) {
      return
    }

    if (original.id) {
      alt.id = original.id
      original.removeAttribute('id')
    }

    const describedBy = original.getAttribute('aria-describedby')
    if (describedBy) {
      alt.setAttribute('aria-describedby', describedBy)
      original.removeAttribute('aria-describedby')
    }
  }
}

const formDate = new FormDate()
formDate.init()
